<style lang="scss" scoped>
.search {
	width: 100%;
	position: absolute;
	.el-form-item__label {
		font-size: 13px;
	}
	display: flex;
	flex-direction: column;
	height: 100%;
	&__switches {
		display: flex;
		padding: 18px;
		color: #eee;
		border-radius: 5px;
		justify-content: space-between;
		background: rgba(50, 50, 50, 0.07);
	}
	&__input {
		height: auto;
		margin: 12px 0;
		padding: 18px;
		border-radius: 5px;
		border: 3px solid #eee;
	}
	&__results {
		position: relative;
		flex: 1;
		overflow-y: scroll;
		margin-top: 24px;
		&--count {
			font-size: 1em;
			color: $grey--200;
			padding: 0;
			margin: 12px 0;
			font-weight: 400;
		}
	}
	&__ready {
		img {
			height: 30px;
			margin-right: 8px;
		}
	}
	&__empty {
		font-size: 20px;
		margin-top: 20px;
	}
}
</style>

<template lang="pug">
    el-drawer(
        withHeader=false
        :visible.sync="isOpen"
        direction="ltr"
        show-close=false
        size=1000)
        template(v-slot:title)
            h3.highlight Search schools
        .search
            .search__switches
                .search__switches--advanced
                    el-switch(
                        v-model="isAdvanced"
                        active-color="#85b500"
                        inactive-color="#808080"
                        active-text="Advanced search")
                .search__switches--associated
                    el-switch(
                        v-model="associatedOnly"
                        active-color="#85b500"
                        inactive-color="#808080"
                        active-text="My schools")
            .search__input
                advanced-search(v-if="isAdvanced", :associatedOnly="associatedOnly")
                simple-search(v-else :associatedOnly="associatedOnly")
            .search__results
                h5.search__results--count(v-if="state !== 'ready'") Displaying {{ sortedResults.length }} {{ sortedResults.length == 1 ? "Result": "Results"}}
                search-row(v-for="row in sortedResults", :key="row.id", :row="row", :associatedSchools="AssociatedSchools", :associatedOnly="associatedOnly")
                empty(v-if="state != 'loaded'", :info="true", :big="false")
                    .search__ready
                        img(src="/info.svg")
                        span Find schools by entering some search terms
                empty(v-if="state == 'loaded' && (!sortedResults || !sortedResults.length)") No results found
</template>

<script>
import gql from "graphql-tag";
import SearchRow from "./includes/Row";
import AdvancedSearch from "./includes/Advanced";
import SimpleSearch from "./includes/Simple";

export default {
	components: {
		SearchRow,
		AdvancedSearch,
		SimpleSearch
	},
	mounted() {
		this.$bus.$on("toggle-search", bool => {
			this.isOpen = bool;
		});
		this.$bus.$on("search-results", results => {
			this.results = results;
			this.state = "loaded";
		});
	},
	data: () => ({
		isOpen: false,
		isAdvanced: false,
		associatedOnly: false,
		state: "ready",
		results: []
	}),
	computed: {
		sortedResults() {
			if (this.associatedOnly) {
				const associatedIds = this.AssociatedSchools.map(s => s.id);
				return this.results.filter(s => associatedIds.includes(s.id));
			}

			return this.results;
		}
	},
	apollo: {
		AssociatedSchools: {
			query: gql`
				query AssociatedSchools($state: String) {
					AssociatedSchools(state: $state) {
						id
						approved
						declined
						demo
					}
				}
			`,
			fetchPolicy: "cache-and-network"
		}
	}
};
</script>
